import { Modal } from 'antd'

const titles = {
    reload: 'אנא רענן את העמוד'
}
export const errorFatalModal = () => {
    Modal.error({ title: titles.fatalError, content: titles.reload, okText: titles.confirm })
}
export const zoomLevel = params => {
    const { screenHeight } = params.state

    let zoomLevel
    if (screenHeight >= 799 && screenHeight <= 900) {
        zoomLevel = '78%'
    } else if (screenHeight >= 699 && screenHeight <= 799) {
        zoomLevel = '69%'
    } else if (screenHeight <= 699 && screenHeight >= 600) {
        zoomLevel = '55%'
    } else {
        zoomLevel = '100%'
    }
    params.setState({ zoomLevel })
}

export const screenType = () => {
    if (window.innerWidth > 1600) {
        return 'desktop'
    } else if (window.innerWidth === 1024) {
        return 'ipad-pro'
    } else if (window.innerWidth > 1022) {
        return 'laptop'
    } else if (window.innerWidth > 624) {
        return 'tablet'
    } else return 'mobile'
}

export const mobileZoom = () => {
    if (window.innerWidth === 320) return '54%'
    if (window.innerWidth === 360) return '64%'
    if (window.innerWidth === 390) return '72%'
    if (window.innerWidth === 412 || window.innerWidth === 414) return '78%'
    return '82%'
}
